import get from 'lodash/get';
import { connect } from 'react-redux';
import { withGetTieredBonus } from 'src/_shared/api/components/tiered-bonuses';
import { compose } from '../../_shared/services/utils.js';
import ReferralCardComponent from 'src/my-referrals/referral-card/ReferralCardComponent';

const mapStateToProperties = (state, ownProperties) => {
	const { currentUser } = state.user;
	const { allMultiLingualData } = state.dashboard;
	const campaignId = get(ownProperties, 'referral.campaignId', null);
	const referralBonusTier = get(ownProperties, 'referral.bonus.tieredBonusId');
	const job = get(ownProperties, 'referral.job');

	let id = 'skip';
	if (campaignId) {
		id = referralBonusTier;
	} else if (job?.tieredBonusId) {
		id = job?.tieredBonusId;
	} else if (job?.referralBonus?.tieredBonusId)  {
		id = job?.referralBonus?.tieredBonusId
	}

	return {
		allMultiLingualData,
		companyId: currentUser.companyId,
		tieredBonusQuery: {
			companyId: currentUser.companyId,
			id,
		},
	};
};

const mapDispatchToProperties = () => {
	return {};
};

export const MyReferralCardWithApi = compose(withGetTieredBonus)(
	ReferralCardComponent
);

export default connect(
	mapStateToProperties,
	mapDispatchToProperties
)(MyReferralCardWithApi);
